export function performanceReviewItemResultRequired(value, vm) {
	if (vm.item && vm.item.rankType === 1) {
		return value !== null;
	}
	return true;
}

export function performanceReviewItemOutcomeResultRequired(value) {
	return value !== null;
}

export function performanceReviewItemCommentRequired(value, vm) {
	if (vm.item && vm.item.rankType === 0) {
		return value !== null && value !== '';
	}
	return true;
}

export function performanceReviewTemplateGroupName(value) {
	return value !== null && value !== '' && !value.includes('New Group');
}
